var map = {
	"./D0010_6_Rights_National_long.1702558500000.jpg": 5772,
	"./D0215.34I-25557_-26599_0.jpg": 5773,
	"./D0215.34I-25557_-26600_0.jpg": 5774,
	"./D0270.34I-25616_-23193_0.1695742800000.jpg": 5775,
	"./D0400.34I-39598_-26865_0.jpg": 5776,
	"./G0020.34I-25843_-15909_0.jpg": 5777,
	"./G0020.34I-25844_-15911_0.jpg": 5778,
	"./G0020.34I-25844_-15913_0.jpg": 5779,
	"./G0020.34I-25844_-15915_0.jpg": 5780,
	"./G0040.Picture1.1722507000000.jpg": 5781,
	"./G0040.SGC1.1722507000000.jpg": 5782,
	"./G0050.34I-26050_-17332_0.1666195680000.jpg": 5783,
	"./G0065.34I-39578_-23527_0.jpg": 5784,
	"./G0065.34I-39579_-23440_0.jpg": 5785,
	"./G0070.Death_of_a_Child_algo_GS_april22.1666194000000.jpg": 5786,
	"./G0070.Expect_child_death_algo_draw_up_GS_april22.1666194000000.jpg": 5787,
	"./G0085.34I-29353_-17022_0.1666192500000.jpg": 5788,
	"./G0100-Figure_5.1.1664356080000.jpg": 5789,
	"./G0110.Adult_Basic_Life_Support_Algorithm_2021_GS.1657102080000.jpg": 5790,
	"./G0120-Adult_Advanced_Life_Support_low_res.1709298180000.jpg": 5791,
	"./G0120-Child_Advanced_Life_Support_low_res.1709298180000.jpg": 5792,
	"./G0120.34I-29369_-17027_0.1666196520000.jpg": 5793,
	"./G0120.34I-29370_-17328_0.1666196640000.jpg": 5794,
	"./G0120.34I-29370_-21492_0-RS.1709298180000.jpg": 5795,
	"./G0120.34I-29375_-17330_0.1666197120000.jpg": 5796,
	"./G0120.34I-29376_-17331_0-RS.1709298180000.jpg": 5797,
	"./G0120.34I-29378_-17035_0.1666197900000.jpg": 5798,
	"./G0120.ALS_HOT_Image.1709298180000.jpg": 5799,
	"./G0125.34I-29381_-17752_0.1666245540000.jpg": 5800,
	"./G0130.Adult_Choking_Algorithm_GS_april22.1666190100000.jpg": 5801,
	"./G0130.Paediatric_Choking_GS_may22.1666265820000.jpg": 5802,
	"./G0140.34I-26068_-15988_0.1666257060000.jpg": 5803,
	"./G0140.34I-26068_-15990_0.1666257060000.jpg": 5804,
	"./G0140.34I-26068_-15992_0.1666257120000.jpg": 5805,
	"./G0140.34I-26068_-15994_0.1666257180000.jpg": 5806,
	"./G0150.Paediatric_Basic_Life_Support_Algorithm_GS.1657018680000.jpg": 5807,
	"./G0160-Figure_5.17_BAPM.1711619160000.jpg": 5808,
	"./G0160-Newborn_Life_Support_algorithm.1711619160000.jpg": 5809,
	"./G0200-Bradycardia-Algorithm.1712155560000.jpg": 5810,
	"./G0210-TLoC.1711031940000.jpg": 5811,
	"./G0245.Mental_Capacity.1658482860000.jpg": 5812,
	"./G0250.CFS_v2.0_EN_Card-2Up.1686225480000.jpg": 5813,
	"./G0250.Medical_Emergencies_in_Adults_1.1657620600000.jpg": 5814,
	"./G0250.Medical_Emergencies_in_Adults_2.1657620960000.jpg": 5815,
	"./G0310.heatrelated1.1692718860000.jpg": 5816,
	"./G0320.34I-26134_-16011_15.1654023300000.jpg": 5817,
	"./G0320.34I-26134_-17342_0.1666261860000.jpg": 5818,
	"./G0330.34I-26141_-16016_0.1666258320000.jpg": 5819,
	"./G0340.34I-26150_-17366_0.1666258680000.jpg": 5820,
	"./G0350.34I-26156_-17337_0.1666262160000.jpg": 5821,
	"./G0350.34I-26158_-17369_0.1666262220000.jpg": 5822,
	"./G0355.34I-26181_-16025_0.1666262220000.jpg": 5823,
	"./G0360.ACS_algo_final_nov_22.1670416320000.jpg": 5824,
	"./G0380-Asthma_algorithm.1710502980000.jpg": 5825,
	"./G0380.34I-26208_-16823_0.1666262400000.jpg": 5826,
	"./G0390.34I-26216_-17367_0.1666262520000.jpg": 5827,
	"./G0390.ChronicObstructivePulmonaryDisease-updated130623sb_GS.1692719220000.jpg": 5828,
	"./G0400.34I-27244_-17343_0.1666263420000.jpg": 5829,
	"./G0400.34I-27245_-22621_0.1666263480000.jpg": 5830,
	"./G0425.34I-22401_-17336_0-(1).1692956700000.jpg": 5831,
	"./G0425.Glycaemic_Omnipod1.1692956460000.jpg": 5832,
	"./G0425.Glycaemic_dexcom1.1692956460000.jpg": 5833,
	"./G0425.Glycaemic_freestyle1.1692956460000.jpg": 5834,
	"./G0425.Glycaemic_tandem1.1692956460000.jpg": 5835,
	"./G0430.34I-27378_-16465_0.1666263600000.jpg": 5836,
	"./G0430_Heart_Failure_Algorithm.1705669080000.jpg": 5837,
	"./G0440-ICD_algorithm_.1702485300000.jpg": 5838,
	"./G0440.34I-26228_-16119_0.1666263600000.jpg": 5839,
	"./G0460-PE-algorithm.1711031940000.jpg": 5840,
	"./G0480.34I-40928_-24259_0.1654023300000.jpg": 5841,
	"./G0480.34I-40928_-24314_0.1654023300000.jpg": 5842,
	"./G0500.34I-26273_-17346_0.1666264020000.jpg": 5843,
	"./G0500.34I-26273_-17347_0.1666264020000.jpg": 5844,
	"./G0510.34I-26280_-16139_0.1654023300000.jpg": 5845,
	"./G0510.34I-26281_-17354_0.1666264140000.jpg": 5846,
	"./G0535.34I-29290_-16971_0.1654019700000.jpg": 5847,
	"./G0535.34I-29298_-16972_0.1654019700000.jpg": 5848,
	"./G0535.34I-29298_-16973_0.1664453340000.jpg": 5849,
	"./G0535.34I-29298_-16974_0.1654019700000.jpg": 5850,
	"./G0535.34I-29302_-16975_0.1654019700000.jpg": 5851,
	"./G0535.34I-29302_-16976_0.1654019700000.jpg": 5852,
	"./G0535.34I-29302_-16977_0.1654019700000.jpg": 5853,
	"./G0535.34I-29302_-16978_0.1654019700000.jpg": 5854,
	"./G0540.34I-26290_-16163_0.1666261620000.jpg": 5855,
	"./G0540.34I-26290_-22027_0.1666261680000.jpg": 5856,
	"./G0540.CFS_v2.0_EN_Card-2Up.1686221880000.jpg": 5857,
	"./G0550.34I-26304_-16172_0.jpg": 5858,
	"./G0550.34I-26304_-22028_0.jpg": 5859,
	"./G0570.34I-26321_-17333_0.1666265340000.jpg": 5860,
	"./G0570.34I-26321_-17334_0.1666265400000.jpg": 5861,
	"./G0570.34I-28261_-24276_0.1720794540000.jpg": 5862,
	"./G0590.34I-26338_-16194_0.1666262520000.jpg": 5863,
	"./G0615.34I-26365_-16205_0.1711031940000.jpg": 5864,
	"./G0615.CFS_v2.0_EN_Card-2Up.1686225480000.jpg": 5865,
	"./G0650-Electrical-injury-algorithm.1721738220000.jpg": 5866,
	"./G0650.34I-26392_-16211_15.1654023360000.jpg": 5867,
	"./G0650.34I-26392_-16213_15.1654023360000.jpg": 5868,
	"./G0660.34I-26400_-16218_15.1654019760000.jpg": 5869,
	"./G0660.34I-26401_-16220_15.1654019760000.jpg": 5870,
	"./G0670.34I-26408_-16223_0.1666266360000.jpg": 5871,
	"./G0670.34I-26410_-24246_0.1654023360000.jpg": 5872,
	"./G0670.34I-26410_-24995_0.1654023360000.jpg": 5873,
	"./G0670.34I-26412_-16225_0.1715850360000.jpg": 5874,
	"./G0670.34I-40934_-24242_0.1654023360000.jpg": 5875,
	"./G0680.34I-26416_-16230_0.1666267020000.jpg": 5876,
	"./G0680.34I-26416_-16232_0.1666267020000.jpg": 5877,
	"./G0680.34I-26416_-16234_0.1666267080000.jpg": 5878,
	"./G0680.34I-26416_-16236_0.1666267140000.jpg": 5879,
	"./G0680.34I-26416_-16238_0.1666267140000.jpg": 5880,
	"./G0680.34I-26416_-16244_0.1666267260000.jpg": 5881,
	"./G0680.34I-26416_-16246_0.1666267260000.jpg": 5882,
	"./G0680.34I-26416_-16248_0.1666267320000.jpg": 5883,
	"./G0680.34I-26416_-16250_0.1666267320000.jpg": 5884,
	"./G0680.34I-26416_-19043_0.1654023360000.jpg": 5885,
	"./G0680.34I-26416_-19044_0.1654023360000.jpg": 5886,
	"./G0680.34I-26416_-19046_0.1654023360000.jpg": 5887,
	"./G0680.34I-26416_-19047_0.1654023360000.jpg": 5888,
	"./G0680.34I-26416_-23782_0.1654023360000.jpg": 5889,
	"./G0680.34I-26417_-18483_0.1666267560000.jpg": 5890,
	"./G0680.34I-26417_-18486_0.1666267620000.jpg": 5891,
	"./G0680.34I-26417_-22029_0.1666267620000.jpg": 5892,
	"./G0680.34I-26417_-24229_0.1654023360000.jpg": 5893,
	"./G0690.34I-26420_-16263_0.1666268100000.jpg": 5894,
	"./G0720.34I-26450_-16300_0.1666268160000.jpg": 5895,
	"./G0720.34I-26450_-16302_0.1666268160000.jpg": 5896,
	"./G0750.34I-27928_-17317_0.1666264620000.jpg": 5897,
	"./G0750.34I-27929_-17384_0.1666264620000.jpg": 5898,
	"./G0750.34I-27930_-16774_0.1666264680000.jpg": 5899,
	"./G0750.34I-27930_-16781_0.1666264680000.jpg": 5900,
	"./G0750.34I-27930_-16783_0.1666264740000.jpg": 5901,
	"./G0750.34I-27930_-16871_0.1654019760000.jpg": 5902,
	"./G0750.34I-27930_-16872_0.1666265100000.jpg": 5903,
	"./G0750.34I-27930_-16873_0.1666265160000.jpg": 5904,
	"./G0750.34I-27930_-16874_0.1666265220000.jpg": 5905,
	"./G0750.34I-27930_-17319_0.1666265220000.jpg": 5906,
	"./G0750.34I-27930_-17320_0.1666265280000.jpg": 5907,
	"./G0750.34I-27930_-17321_0.1666265280000.jpg": 5908,
	"./G0750.34I-27930_-17361_0.1666265400000.jpg": 5909,
	"./G0750.34I-27930_-17362_0.1666265460000.jpg": 5910,
	"./G0750.Laryngectomy_Tube.1658760060000.jpg": 5911,
	"./G0750.Trachy_and_Lary_2.18.1666267500000.jpg": 5912,
	"./G0750.Trachy_and_Lary_2.19.1667402940000.jpg": 5913,
	"./G0760.34I-32543_-17836_0.1654023360000.jpg": 5914,
	"./G0780.34I-36923_-21732_0.1654023360000.jpg": 5915,
	"./G0780.34I-36923_-22032_0.1654023360000.jpg": 5916,
	"./G0780.34I-36930_-21726_0.1654023360000.jpg": 5917,
	"./G0780.34I-36930_-21728_0.1666269180000.jpg": 5918,
	"./G0790.Dermatomes.1657795800000.jpg": 5919,
	"./G0790.LB1_Redrawn.1657796460000.jpg": 5920,
	"./G0790.LBP2_redrawn.1657796400000.jpg": 5921,
	"./G0800.34I-41948_-25141_0.1654019760000.jpg": 5922,
	"./G0810-CRESS.1710502860000.jpg": 5923,
	"./G0810-RAR.1710502860000.jpg": 5924,
	"./G0810-Radiation_trefoil.1710502860000.jpg": 5925,
	"./G0810-RemoveRemoveRemove.1710502860000.jpg": 5926,
	"./G0840.Mental_Health-02_(1).1683621780000.jpg": 5927,
	"./G0860.Breech_01_footling.1695376380000.jpg": 5928,
	"./G0860.Breech_02_SemiR.1695377580000.jpg": 5929,
	"./G0860.Breech_02a_SemiR.1695379680000.jpg": 5930,
	"./G0860.Breech_03_AllFours.1695377760000.jpg": 5931,
	"./G0860.Breech_03a_AllFours.1695379740000.jpg": 5932,
	"./G0860.Breech_04_Pelvic_hold.1695377880000.jpg": 5933,
	"./G0860.Breech_05-AllFours-baby_out.1695378000000.jpg": 5934,
	"./G0860.Breech_05a-AllFours-baby_out.1695379740000.jpg": 5935,
	"./G0860.Breech_05b-AllFours-baby_out.1695379800000.jpg": 5936,
	"./G0860.Breech_06-SemiR-baby_out.1695378180000.jpg": 5937,
	"./G0860.Breech_06a-SemiR-baby_out.1695379800000.jpg": 5938,
	"./G0860.Breech_07-SemiR-head_delay.1695378480000.jpg": 5939,
	"./G0860.Breech_08-SemiR-head_delay2.1695378600000.jpg": 5940,
	"./G0860.Breech_09-AllFours-Shoulder_Press.1695378780000.jpg": 5941,
	"./G0860.Breech_Birth_Algorithm_-_Photos.1693835940000.jpg": 5942,
	"./G0860.Breech_allfours2.1692872880000.jpg": 5943,
	"./G0860.Breech_allfours_delay2.1692880560000.jpg": 5944,
	"./G0860.Breech_allfours_handing2.1692873900000.jpg": 5945,
	"./G0860.Breech_allfours_manage2.1692878040000.jpg": 5946,
	"./G0860.Breech_allfours_manage4.1692879900000.jpg": 5947,
	"./G0860.Breech_semir_handing2.1692873900000.jpg": 5948,
	"./G0860.Breech_semirecum2.1692872820000.jpg": 5949,
	"./G0860.Breech_semirecum_delay2.1692880500000.jpg": 5950,
	"./G0860.Breech_semirecum_delay4.1692880560000.jpg": 5951,
	"./G0860.Breech_semirecum_manage2.1692878100000.jpg": 5952,
	"./G0860.Breech_semirecum_manage4.1692879900000.jpg": 5953,
	"./G0860.breech_footling2.1692872820000.jpg": 5954,
	"./G0870.G0720.34I-26450_-16300_0.1666268160000.jpg": 5955,
	"./G0880-Management_of_bleeding.1702899420000.jpg": 5956,
	"./G0890-Management_of_PPH_flowchart.1702899480000.jpg": 5957,
	"./G0890_Bimanual_compression.1702917960000.jpg": 5958,
	"./G0890_Blood_volumes.1703839800000.jpg": 5959,
	"./G0890_PPH_massage.1702984680000.jpg": 5960,
	"./G0900_1.1719486180000.jpg": 5961,
	"./G0900_2.1719486180000.jpg": 5962,
	"./G0900_3.1719486180000.jpg": 5963,
	"./G0900_4.1719486180000.jpg": 5964,
	"./G0905.G0900_1.1719486180000.jpg": 5965,
	"./G0905.G0900_2.1719486180000.jpg": 5966,
	"./G0905.G0900_3.1719486180000.jpg": 5967,
	"./G0905.G0900_4.1719486180000.jpg": 5968,
	"./P0005.P0010.34I-27214_-17239_0.1695742800000.jpg": 5969,
	"./P0005.P0010.34I-27214_-17240_0.1695742800000.jpg": 5970,
	"./P0005.P0010.34I-27214_-17241_0.1695742800000.jpg": 5971,
	"./P0005.P0010.34I-27214_-17242_0.1695742800000.jpg": 5972,
	"./P0010.34I-27214_-17239_0.1695742800000.jpg": 5973,
	"./P0010.34I-27214_-17240_0.1695742800000.jpg": 5974,
	"./P0010.34I-27214_-17241_0.1695742800000.jpg": 5975,
	"./P0010.34I-27214_-17242_0.1695742800000.jpg": 5976,
	"./P0020.34I-27305_-17247_0.1695742800000.jpg": 5977,
	"./P0020.34I-27305_-17248_0.1695742800000.jpg": 5978,
	"./P0020.34I-27305_-17249_0.1695742800000.jpg": 5979,
	"./P0020.34I-27305_-17250_0.1695742800000.jpg": 5980,
	"./P0030.34I-27309_-17251_0.1695742800000.jpg": 5981,
	"./P0030.34I-27309_-17252_0.1695742800000.jpg": 5982,
	"./P0030.34I-27309_-17253_0.1695742800000.jpg": 5983,
	"./P0030.34I-27309_-17254_0.1695742800000.jpg": 5984,
	"./P0040.34I-27313_-17255_0.1695742800000.jpg": 5985,
	"./P0040.34I-27313_-17256_0.1695742800000.jpg": 5986,
	"./P0040.34I-27313_-17257_0.1695742800000.jpg": 5987,
	"./P0040.34I-27313_-17258_0.1695742800000.jpg": 5988,
	"./P0050.34I-27317_-17259_0.1695742800000.jpg": 5989,
	"./P0050.34I-27317_-17260_0.1695742800000.jpg": 5990,
	"./P0050.34I-27317_-17261_0.1695742800000.jpg": 5991,
	"./P0050.34I-27317_-17262_0.1695742800000.jpg": 5992,
	"./P0060.34I-27321_-17263_0.1695742800000.jpg": 5993,
	"./P0060.34I-27321_-17264_0.1695742800000.jpg": 5994,
	"./P0060.34I-27321_-17265_0.1695742800000.jpg": 5995,
	"./P0060.34I-27321_-17266_0.1695742800000.jpg": 5996,
	"./P0070.34I-27325_-17267_0.1695742800000.jpg": 5997,
	"./P0070.34I-27325_-17268_0.1695742800000.jpg": 5998,
	"./P0070.34I-27325_-17269_0.1695742800000.jpg": 5999,
	"./P0070.34I-27325_-17270_0.1695742800000.jpg": 6000,
	"./P0080.34I-27329_-17271_0.1695742800000.jpg": 6001,
	"./P0080.34I-27329_-17272_0.1695742800000.jpg": 6002,
	"./P0080.34I-27329_-17273_0.1695742800000.jpg": 6003,
	"./P0080.34I-27329_-17274_0.1695312480000.jpg": 6004,
	"./P0090.34I-27333_-17275_0.1695742800000.jpg": 6005,
	"./P0090.34I-27333_-17276_0.1695742800000.jpg": 6006,
	"./P0090.34I-27333_-17277_0.1695742800000.jpg": 6007,
	"./P0090.34I-27333_-17278_0.1695742800000.jpg": 6008,
	"./P0100.34I-27337_-17279_0.1695742800000.jpg": 6009,
	"./P0100.34I-27337_-17280_0.1695742800000.jpg": 6010,
	"./P0100.34I-27337_-17281_0.1695742800000.jpg": 6011,
	"./P0100.34I-27337_-17282_0.1695742800000.jpg": 6012,
	"./P0110.34I-27341_-17283_0.1695742800000.jpg": 6013,
	"./P0110.34I-27341_-17284_0.1695742800000.jpg": 6014,
	"./P0110.34I-27341_-17285_0.1695742800000.jpg": 6015,
	"./P0110.34I-27341_-17286_0.1695742800000.jpg": 6016,
	"./P0120.34I-27345_-17287_0.1695742800000.jpg": 6017,
	"./P0120.34I-27345_-17288_0.1695742800000.jpg": 6018,
	"./P0120.34I-27345_-17289_0.1695742800000.jpg": 6019,
	"./P0120.34I-27345_-17290_0.1695742800000.jpg": 6020,
	"./P0130.34I-27349_-17291_0.1695742800000.jpg": 6021,
	"./P0130.34I-27349_-17292_0.1695742800000.jpg": 6022,
	"./P0130.34I-27349_-17293_0.1695742800000.jpg": 6023,
	"./P0130.34I-27349_-17294_0.1695742800000.jpg": 6024,
	"./P0140.34I-27353_-17295_0.1695742800000.jpg": 6025,
	"./P0140.34I-27353_-17296_0.1695742800000.jpg": 6026,
	"./P0140.34I-27353_-17297_0.1695742800000.jpg": 6027,
	"./P0140.34I-27353_-17298_0.1695742800000.jpg": 6028,
	"./P0150.34I-27357_-17299_0.1695742800000.jpg": 6029,
	"./P0150.34I-27357_-17300_0.1695742800000.jpg": 6030,
	"./P0150.34I-27357_-17301_0.1695742800000.jpg": 6031,
	"./P0150.34I-27357_-17302_0.1695742800000.jpg": 6032,
	"./P0160.34I-27361_-17303_0.1695742800000.jpg": 6033,
	"./P0160.34I-27361_-17304_0.1695742800000.jpg": 6034,
	"./P0160.34I-27361_-17305_0.1695742800000.jpg": 6035,
	"./P0160.34I-27361_-17306_0.1695742800000.jpg": 6036,
	"./P0170.34I-27365_-17307_0.1695742800000.jpg": 6037,
	"./P0170.34I-27365_-17308_0.1695742800000.jpg": 6038,
	"./P0170.34I-27365_-17309_0.1695742800000.jpg": 6039,
	"./P0170.34I-27365_-17310_0.1695742800000.jpg": 6040,
	"./S0020-Figure_6.1.1658498700000.jpg": 6041,
	"./S0020.34I-26471_-17356_0.1666270620000.jpg": 6042,
	"./S0020.34I-26481_-16320_0.1666270920000.jpg": 6043,
	"./S0020_6.10.1704210900000.jpg": 6044,
	"./S0020_6.12_TST_bands.1702919220000.jpg": 6045,
	"./S0020_6.13_TST_algorithm.1702919280000.jpg": 6046,
	"./S0020_6.14_MITT_algorithm.1702919280000.jpg": 6047,
	"./S0020_6.6_METHANE.1702919100000.jpg": 6048,
	"./S0020_6.8_JDM.1702919160000.jpg": 6049,
	"./S0020_6.9_IIMARCH.1702919220000.jpg": 6050,
	"./S0020_RunHideTell.1703768040000.jpg": 6051,
	"./S0100.Fig6.9-NEW.1657890600000.jpg": 6052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5771;